/**
 * Created by Ivan on 19/05/2017.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
Vue.use(Vuex);

let language = 'es';


const store = new Vuex.Store({
    state : {
        language,
        settings : null,
        languageAvailables : []
    },
    getters : {
        lang : (state) => {
            return state.language;
        },
        languageAvailables : (state) => {
            return state.languageAvailables;
        },
        config : (state) => {
            return state.settings;
        }
    },
    mutations : {
        lang( state, lang ){
            state.language = lang;
        },
        settings(state, data){
            state.settings = data;
            let keys = [];
            for(let k in state.settings.lang) keys.push(k);
            state.languageAvailables = keys;
        }
    },

});

export default store;


// WEBPACK FOOTER //
// ./src/store.js